/**
 * Auth adapter selector — the single place that maps VITE_AUTH_MODE to a concrete
 * adapter. Defaults to Clerk; `dev` is opt-in (and the API refuses dev mode in
 * production, so the two sides can only diverge locally).
 */
import { clerkAdapter } from './clerk-adapter';
import { devAdapter } from './dev-adapter';
import type { AuthAdapter } from './types';

export type { AuthAdapter } from './types';

const mode = import.meta.env.VITE_AUTH_MODE ?? 'clerk';

export const authAdapter: AuthAdapter = mode === 'dev' ? devAdapter : clerkAdapter;
